import { Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useGetPriceQuery } from "src/api/services/pricesApi";
import { MatchParam } from "src/constants/matches";
import DaysSupply from "./components/DaysSupply";
import Titrations from "./components/Titrations";

const PriceDetails = () => {
  const { priceId } = useParams<MatchParam<"PRICE_ID">>();

  const { data } = useGetPriceQuery(priceId ? Number(priceId) : skipToken);

  if (data == null) {
    return (
      <Typography>
        Looks like this price is missing some vital information
      </Typography>
    );
  }

  return (
    <Stack width={"100%"} gap={2}>
      <Typography
        variant="h5"
        sx={{ textDecoration: "underline" }}
        textAlign={"center"}
        fontSize={"2rem"}
      >
        {data.name} ({data.number_of_months} month(s))
      </Typography>
      <Stack direction={"row"} gap={5}>
        <DaysSupply price={data} />
        <Titrations price={data} />
      </Stack>
    </Stack>
  );
};

export default PriceDetails;
